import axios, { type AxiosResponse } from '@/api/axios';
import { useMutation, type DefaultError } from '@tanstack/react-query';
import {
  Routes,
  type ApplicationApplyPayload,
  type ApplicationApplyResponse,
} from '@/api/types.ts';

export const useApplicationsApplyMutation = () => {
  const url = Routes.ApplicationsApply;

  return useMutation<
    ApplicationApplyResponse,
    DefaultError,
    ApplicationApplyPayload
  >({
    mutationFn: async (payload) => {
      const response = await axios.post<
        ApplicationApplyResponse,
        AxiosResponse<ApplicationApplyResponse>,
        ApplicationApplyPayload
      >(url, {
        ...payload,
      });

      return response.data;
    },
  });
};
